var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-4 d-grid"},_vm._l((_vm.data),function(card,i){return _c('a',{key:i,staticClass:"btn btn-dark text-white mb-3",attrs:{"href":card.link}},[_vm._v(" "+_vm._s(card.titulo)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }